import { render, staticRenderFns } from "./GiftMessage.vue?vue&type=template&id=2c55c198&scoped=true&"
import script from "./GiftMessage.vue?vue&type=script&lang=js&"
export * from "./GiftMessage.vue?vue&type=script&lang=js&"
import style0 from "./GiftMessage.vue?vue&type=style&index=0&id=2c55c198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55c198",
  null
  
)

export default component.exports